import React, { Component } from 'react';
import LoginFormContainer from './LoginFormContainer';
import StandardOverlay from '../../components/blueprintWrappers/StandardOverlay';
import LoginOverlayParent from '../../components/login/LoginOverlayParent';
import { connect } from 'react-redux';
import { cookie } from '../../utilities/Utility';

/**
 * Renders: StandardOverlay, {@link LoginOverlayParent}, {@link LoginFormContainer}
 * @props login - redux -> state.login
 * @returns StandardOverlay, LoginOverlayParent, LoginFormContainer 
 */
class LoggedInContainer extends Component {
	render() {
		const isLoggedIn = this.isLoggedIn();
		if(isLoggedIn) {
			return null;			
		} 
		return this.loginOverlay();
	};
	
	loginOverlay = () => {
		return <StandardOverlay isOpen = { true }>
			<LoginOverlayParent>
				<LoginFormContainer />
			</LoginOverlayParent>
		</StandardOverlay>
	};
	
	isLoggedIn = () => {
		const { requiresLogin } = this.props.login;
		const requiresRelog = cookie.get('requiresRelog');
		return (requiresRelog === 'false' || requiresLogin === false);
	};
}

function mapStateToProps(state) { 
	return {
		login: state.login
	}; 
} 


export default connect(mapStateToProps, null)(LoggedInContainer);


// WEBPACK FOOTER //
// ./src/containers/login/LoggedInContainer.js